import { IUpdateStaffRequestQueryParams } from "@endpoints/types/hiringCompany/staffMember.type";
import api from "../../api";
import axios from "../../utils/axios.instance";
import handleError from "../handle-error";

interface IPagination {
    page: number
    limit: number
    searchText?: string
}


export const getHiringCompanyMembers = async ({ page, limit, searchText }: IPagination = {
    page: 1,
    limit: 10
}) => {
    try {
        const params = new URLSearchParams();
        if (page !== undefined) params.append("page", page.toString());
        if (limit !== undefined) params.append("limit", limit.toString());
        if (searchText) params.append("searchText", searchText);

        const url = params.toString()
            ? `${api.hiringCompanyMembers}?${params.toString()}`
            : api.hiringCompanyMembers;
        const { data } = await axios.get(url);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const inviteHiringStaff = async (payload) => {
    try {
        const { data } = await axios.post(api.inviteHiringStaff, payload);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const updateStaffRequest = async ({ userId, status }: IUpdateStaffRequestQueryParams) => {
    try {
        const params = new URLSearchParams();
        params.append('id', userId)
        params.append('status', status.toString())
        const { data } = await axios.get(api.updateStaffRequest + `?${params.toString()}`);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};
